import * as React from 'react';
import PropTypes from 'prop-types';
import { decodeHTMLEntities } from '../utils';

const ContentEditable = ({ content, setContent, placeholder }) => {
  const onContentInputHandler = (event) => {
    setContent(() => decodeHTMLEntities(event.target.innerHTML));
  };

  React.useEffect(() => {
    const contentDiv = document.querySelector('.content-editable');
    if (content === '' && contentDiv) {
      contentDiv.innerHTML = '';
    }
  }, [content]);

  return (
    <div
      className="w-full rounded-md border p-3 text-black placeholder-[#929DA7] outline-none transition focus:border-[#F48023] active:border-[#F48023] disabled:cursor-default disabled:bg-[#F5F7FD] bg-white min-h-[150px] data-[placeholder]:empty:before:content-[attr(data-placeholder)] data-[placeholder]:empty:before:text-[#929DA7] content-editable"
      data-placeholder={placeholder}
      contentEditable
      data-testid="content-editable-input"
      onInput={onContentInputHandler}
    />
  );
};

ContentEditable.propTypes = {
  content: PropTypes.string.isRequired,
  setContent: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
};

export default ContentEditable;
